import { render, staticRenderFns } from "./StudyConversationMessageEditor.vue?vue&type=template&id=514f8bf4&scoped=true"
import script from "./StudyConversationMessageEditor.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageEditor.vue?vue&type=style&index=0&id=514f8bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f8bf4",
  null
  
)

export default component.exports